import { useContext } from "react";
import { MessageContext } from "../../store/MessageContext";

export const useToast = () => {
  const { messageApi } = useContext(MessageContext);
  const duration = 3;

  const showToast = (msg, type = "info") => {
    switch (type) {
      case "success":
        messageApi.success(msg, duration);
        break;
      case "error":
        messageApi.error(msg, duration);
        break;
      case "warning":
        messageApi.warning(msg, duration);
        break;
      case "loading":
        messageApi.loading(msg, duration);
        break;
      default:
        messageApi.info(msg, duration);
    }
  };

  return showToast;
};
